/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import $ from 'jquery'
// eslint-disable-next-line lodash-fp/use-fp, lodash-fp/consistent-name
import { cloneDeep } from 'lodash'
import moment from 'moment-timezone'
import React, { Component, Fragment } from 'react'
import injectSheet from 'react-jss'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { CLINIC_DATES_URL } from '../../api/endpoints'
import Button from '../../components/Button'
import Spinner from '../../components/Spinner'
import * as actionCreators from '../../root/actions'
import Calendar from './CalendarComponent'
import SelectedAppointment from './SelectedAppointmentContainer'
import style from './style'

export class Schedule extends Component {
  state = {
    isGettingDates: false,
    isLoadingTimer: true,
    isGotoPaymentMobile: false
  }

  getAppointmentDates() {
    const { props } = this
    const { apiRequest } = props
    const { schedule } = props.containers
    const month = schedule.get('month')
    this.props.resetTimeslots()

    this.setState({ isGettingDates: true }, () => {
      const request = {
        method: 'get',
        url: CLINIC_DATES_URL,
        params: { month }
      }

      const meta = {
        Component: 'Schedule',
        isGettingDates: true,
        onSuccess: () => {
          this.setState({ isGettingDates: false })
        },
        assert: {
          item: month,
          test: 'isDate',
          hasError: false,
          error: null
        }
      }

      apiRequest(request, meta)
    })
  }

  componentDidMount() {
    const { app } = this.props.containers

    this.props.highlightNavbarSection('upcomingVisit') // activate sidebar highlight
    this.props.selectTimeslot(null)
    if (app.get('upcomingVisit') === null) {
      setTimeout(() => this.props.setProgressBarPercent(25), 2500)
    }
    setTimeout(() => this.setState({ isLoadingTimer: false }), 2000)
  }

  UNSAFE_componentWillMount() {
    this.props.resetTimeslots()
    this.getAppointmentDates()
  }

  componentWillUnmount() {
    this.props.resetTimeslots()
    this.props.setProgressBarPercent(0) // reset progress bar
  }

  resetMobileState() {
    this.setState({ isGotoPaymentMobile: false })
  }

  render() {
    const { schedule, app } = this.props.containers
    const { classes } = this.props
    // const { onSelection } = config.schedule

    const timeslots = cloneDeep(schedule.get('timeslots'))

    const selectedTimeslot = schedule.get('selectedTimeslot')
    const upcomingVisit = app.get('upcomingVisit')

    if (upcomingVisit !== null) {
      if (timeslots.times) timeslots.times.push({ time: upcomingVisit.date })
    } // add upcoming visit to calendar too

    const onSelection = timeslot => {
      this.props.selectTimeslot(timeslot)
    }
    const isMobile = app.get('isMobile')
    const isScheduleReady =
      // timeslots.length >= 1 &&
      !this.state.isLoadingTimer && !schedule.get('isCancelFromUpcomingVisit')

    const onIncreaseMonth = () => {
      const viewedMonth = schedule.get('month')
      const nextMonth = moment(viewedMonth).add(1, 'M')

      if (nextMonth.isAfter(moment().add(2, 'M'))) return

      this.props.increaseMonth()
      this.setState({ isLoadingTimer: true })
      setTimeout(() => this.setState({ isLoadingTimer: false }), 3000)

      setTimeout(this.getAppointmentDates, 300) // use callback instead
    }
    const onDecreaseMonth = () => {
      const viewedMonth = schedule.get('month')

      const lastMonth = moment(viewedMonth).subtract(1, 'M')

      if (lastMonth.isBefore(moment().subtract(1, 'M'))) return
      this.props.decreaseMonth()
      this.setState({ isLoadingTimer: true })
      setTimeout(() => this.setState({ isLoadingTimer: false }), 3000)

      setTimeout(this.getAppointmentDates, 300) // use callback instead
    }

    const calendarProps = {
      timeslots,
      onSelection,
      isMobile,
      upcomingVisit: app.get('upcomingVisit'),
      onIncreaseMonth,
      onDecreaseMonth,
      isGettingDates: this.state.isGettingDates,
      month: schedule.get('month')
    }

    const selectedAppointmentProps = {
      upcomingVisit,
      resetMobileState: this.resetMobileState
    }

    return (
      <div className={classes.base}>
        {isScheduleReady ? (
          <Fragment>
            {!isMobile ||
              (isMobile && !this.state.isGotoPaymentMobile) ||
              selectedTimeslot === null ||
              upcomingVisit !== null ? (
              <Fragment>
                <div className="section-title mobile-padding">
                  <h2 className="noMarginPadding">
                    {upcomingVisit !== null
                      ? 'Reschedule Your Visit'
                      : 'Schedule Your Visit'}
                  </h2>
                  {upcomingVisit !== null ? (
                    <Fragment>
                      <br />
                    </Fragment>
                  ) : null}
                  <h6 className="footnote schedule-note">
                    <Fragment>
                      {upcomingVisit !== null && (
                        <div className={classes.existingApptNote}>
                          Existing Appointment: {isMobile && <br />}
                          <span className={classes.upcomingVisitSmall}>
                            {upcomingVisit.longFormattedDate}
                          </span>
                        </div>
                      )}
                      {!isMobile ? '* ' : ''}{' '}
                      {(isMobile && upcomingVisit === null) || !isMobile
                        ? 'Plan at least 90 minutes for your visit'
                        : ''}
                    </Fragment>
                  </h6>
                </div>
                <Calendar {...calendarProps} />
                {isMobile && upcomingVisit === null ? (
                  <Button
                    fixed
                    fullWidth
                    disabled={selectedTimeslot === null}
                    onClick={() => {
                      this.setState({ isGotoPaymentMobile: true })
                      $('.main-content, .main-content div').scrollTop(0)
                    }}
                  >
                    Next
                  </Button>
                ) : null}
                <div style={{ height: '1px', position: 'relative' }}>
                  &nbsp;
                </div>
              </Fragment>
            ) : null}

            {((selectedTimeslot !== null || upcomingVisit !== null) &&
              (!isMobile ||
                (isMobile &&
                  (this.state.isGotoPaymentMobile === true ||
                    upcomingVisit !== null)))) ||
              schedule.get('isCancelFromUpcomingVisit') ? (
              <SelectedAppointment {...selectedAppointmentProps} />
            ) : null}
          </Fragment>
        ) : schedule.get('isCancelFromUpcomingVisit') ? (
          <SelectedAppointment {...selectedAppointmentProps} />
        ) : (
          <Spinner />
        )}
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { containers } = state

  return {
    containers
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(actionCreators, dispatch)
}

export default injectSheet(() => style)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Schedule)
)
